import type { StatusTone } from '../../../ui-kit';
import type { CqCarrier, CqQuoteCard } from '../../../services/carrierQuotingService';

/** The chip a quote wears in the list and at the top of its own window. */
export function stageChip(quote: Pick<CqQuoteCard, 'status' | 'stage' | 'needs_you'>): {
  tone: StatusTone; label: string; pulse?: boolean;
} {
  switch (quote.status) {
    case 'reading': return { tone: 'neutral', label: 'Reading the documents', pulse: true };
    case 'review': return { tone: 'warning', label: 'Waiting for you to confirm' };
    case 'quoting': return { tone: 'neutral', label: 'Asking the carriers', pulse: true };
    case 'failed': return { tone: 'bad', label: 'Could not be read' };
    default: return quote.needs_you
      ? { tone: 'warning', label: 'One carrier waiting for you' }
      : { tone: 'good', label: 'Proposal ready' };
  }
}

/** The chip one carrier wears on its tile. */
export function carrierChip(carrier: Pick<CqCarrier, 'status'>): { tone: StatusTone; label: string; pulse?: boolean } {
  switch (carrier.status) {
    case 'queued': return { tone: 'neutral', label: 'Working', pulse: true };
    case 'needs_you': return { tone: 'warning', label: 'Ready for you to submit' };
    case 'quoted': return { tone: 'good', label: 'Quoted' };
    case 'referred': return { tone: 'warning', label: 'Referred to underwriting' };
    default: return { tone: 'bad', label: 'Declined' };
  }
}

/** "1.2 MB", "840 KB". */
export function sizeOf(bytes: number): string {
  if (bytes >= 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${Math.max(1, Math.round(bytes / 1024))} KB`;
}

/** "$1,267.33". */
export const money = (value: number | null | undefined): string =>
  value == null ? '—' : `$${value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

/** "$1,267". */
export const dollars = (value: number | null | undefined): string =>
  value == null ? '—' : `$${Math.round(value).toLocaleString()}`;
